import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent
} from '@mui/material';
import { Schedule } from '@mui/icons-material';
import ScheduledPostsMonitor from '../components/Posts/ScheduledPostsMonitor';

const SchedulePage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
        <Schedule sx={{ fontSize: 40, color: 'primary.main' }} />
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Post Scheduler
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Monitor and manage your scheduled posts with real-time countdown and Celery status
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ScheduledPostsMonitor refreshInterval={30000} />
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                How it works
              </Typography>
              <Typography variant="body2" paragraph>
                • Posts are created as drafts first, then scheduled using APScheduler + Celery
              </Typography>
              <Typography variant="body2" paragraph>
                • Real-time countdown shows exact time remaining until publication
              </Typography>
              <Typography variant="body2" paragraph>
                • Green status indicates the post is properly scheduled in the system
              </Typography>
              <Typography variant="body2" paragraph>
                • Red status indicates scheduling issues that need attention
              </Typography>
              <Typography variant="body2" paragraph>
                • The monitor refreshes every 30 seconds to show current status
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SchedulePage; 